module.exports = __webpack_public_path__ + "media/images/banner/umana_desktop-29d0f49d7b3bbfd083e113d83fac018c.png";